import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Call.scss';
import ReactMarkdown from 'react-markdown'
import { useLocation } from "react-router-dom";

//Loader
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const Loader = () => {
    return (
        <SkeletonTheme baseColor="#EBF0F8" highlightColor="#EBF0F8">
            <p>
                <Skeleton />
            </p>
        </SkeletonTheme>
    )
}

const Call = () => {
    const location = useLocation();
    const [games, setGames] = useState([]);
    const [error, setError] = useState(null);
    let currentUrlId = Number(location.pathname.split('/')[2]);
    // Fetch your games immediately after the component is mounted
    useEffect(() => {
        try {
            axios.get('https://admin.capncovers.com/api/games')
                .then((response) => setGames(response.data.data));
        } catch (error) {
            setError(error)
        }

    }, []);
    if (error) {
        return <div>An error occured: {error.message}</div>;
    }
    let displayData = {}
    for (let i = 0; i < games.length; i++) {
        const game = games[i];
        let id = game.id;
        if (id === currentUrlId) displayData = game;
    }
    return (
        <div className='information'>

            <div className='gameBanner'>
                <h1>{typeof displayData.attributes != "undefined" ? displayData.attributes.title : <Loader />}</h1>
                <h3>Our Rating: {typeof displayData.attributes != "undefined" ? displayData.attributes.rating : "0"}/5</h3>
            </div>

            <div className='teamInfo'>
                <table className="table table-borderless">
                    <thead>
                        <tr>
                            <th scope="col">Team</th>
                            <th scope="col">Spread</th>
                            <th scope="col">Total</th>
                            <th scope="col">Moneyline</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">{typeof displayData.attributes != "undefined" ? displayData.attributes.team1 : <Loader />}</th>
                            <td>{typeof displayData.attributes != "undefined" ? displayData.attributes.spread1 : <Loader />}</td>
                            <td>{typeof displayData.attributes != "undefined" ? displayData.attributes.moneyline1 : <Loader />}</td>
                            <td>{typeof displayData.attributes != "undefined" ? displayData.attributes.total1 : <Loader />}</td>
                        </tr>
                        <tr>
                            <th scope="row">{typeof displayData.attributes != "undefined" ? displayData.attributes.team2 : <Loader />}</th>
                            <td>{typeof displayData.attributes != "undefined" ? displayData.attributes.spread2 : <Loader />}</td>
                            <td>{typeof displayData.attributes != "undefined" ? displayData.attributes.moneyline2 : <Loader />}</td>
                            <td>{typeof displayData.attributes != "undefined" ? displayData.attributes.total2 : <Loader />}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className='articleContainer'>
                <ReactMarkdown className='subTitle'>{typeof displayData.attributes != "undefined" ? displayData.attributes.body : "Loading..."}</ReactMarkdown>
            </div>
        </div>

    );
}

export default Call;

